import type { Step } from 'react-joyride';

export interface SessionsListTourStep extends Step {
  data?: { tab?: number };
}

export const sessionsListSteps: SessionsListTourStep[] = [
  {
    target: '.fert-work-page',
    title: 'Welcome to Fert Work',
    content:
      'This is the Fert Work Sessions page. Here you can create, view, and manage fertilization work sessions. This walkthrough will guide you through both the Recent Sessions and Session History tabs.',
    placement: 'center',
    disableBeacon: true,
    data: { tab: 0 },
  },
  {
    target: '[data-tour="new-session-btn"]',
    title: 'Create a Session',
    content:
      'Click here to start a new fertilization session by picking an aspiration date and fert site.',
    placement: 'bottom',
    disableBeacon: true,
    data: { tab: 0 },
  },
  {
    target: '[data-tour="session-tabs"]',
    title: 'Session Tabs',
    content:
      'Switch between Recent Sessions for active work and Session History for past records.',
    placement: 'bottom',
    disableBeacon: true,
    data: { tab: 0 },
  },
  {
    target: '[data-tour="sessions-grid"]',
    title: 'Recent Sessions',
    content:
      'Shows the most recent session per site. Double-click any row to open it. Each row shows the site, date, and current status.',
    placement: 'top',
    disableBeacon: true,
    data: { tab: 0 },
  },

  {
    target: '[data-tour="sessions-grid"]',
    title: 'Session History',
    content:
      'The Session History tab shows all sessions across all sites with advanced filtering and bulk actions.',
    placement: 'center',
    disableBeacon: true,
    data: { tab: 1 },
  },
  {
    target: '[data-tour="history-filters"]',
    title: 'History Filters',
    content:
      'Filter sessions by site, date, status, or technician. Use the clear button to reset all filters at once.',
    placement: 'bottom',
    disableBeacon: true,
    data: { tab: 1 },
  },
  {
    target: '[data-tour="history-grid"]',
    title: 'History Grid',
    content:
      'All sessions are listed here with details including status, created by, run count, and aspiration date. Select rows with checkboxes for bulk actions, or double-click a row to open it.',
    placement: 'top',
    disableBeacon: true,
    data: { tab: 1 },
  },
];
